import { createFileRoute, redirect } from "@tanstack/react-router"
import { z } from "zod"

import { CreateAccountLink } from "@/components/account/CreateAccountLink"
import {
  PasswordResetResultText,
  VerifyResultText,
} from "@/components/account/LoginForm"
import { LoginPanels } from "@/components/account/LoginPanels"
import { useSessionToasts } from "@/lib/session"

export const Route = createFileRoute("/(public)/_account/login")({
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    verified: z.boolean().optional(),
    resetComplete: z.boolean().optional(),
  }),
  beforeLoad: ({ context: { store }, search }) => {
    if (store.getState().isAuthenticated) {
      throw redirect({ to: search.redirect || "/" })
    }
  },
  component: RouteComponent,
  wrapInSuspense: false,
})

function RouteComponent() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  useSessionToasts()

  return (
    <>
      <VerifyResultText verified={search.verified} />
      <PasswordResetResultText resetComplete={search.resetComplete} />
      <div className="mb-4">
        <h2 className="text-[26px] font-bold text-neutral-800 lg:text-4xl">
          Sign in
        </h2>
        {/* The mobile header carries this cross-link now, so showing it
            here too would offer "Create now" twice on one screen. */}
        <div className="hidden lg:block">
          <CreateAccountLink />
        </div>
      </div>

      <LoginPanels
        onSuccess={() => navigate({ to: search.redirect || "/" })}
        onForgotPassword={() => navigate({ to: "/forgot-password" })}
      />
    </>
  )
}
